// @ts-nocheck

import { map } from 'lodash';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import styled from 'styled-components';

import useRouter from '../../hooks/useRouter';
import GridsDesktopSubMenuContainer from '../../modules/grids/containers/menu/GridsDesktopSubMenuContainer';
import { isGridHistory } from '../../modules/grids/utils/routes';
import routes from '../../routes/grids';
import type { Licence } from '../../types/common';
import DesktopGridsLayoutLeftColumn from '../DesktopGridsLayoutLeftColumn';
import DesktopGridsLayoutMiddleColumn from '../DesktopGridsLayoutMiddleColumn';
import DesktopGridsLayoutRightColumn from '../DesktopGridsLayoutRightColumn';
import DesktopGridsModalLayout from '../DesktopGridsModalLayout';

const GridsLayoutWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: start;
  justify-content: center;
  overflow: auto;
`;

type DesktopGridsLayoutProps = {
  licence: Licence;
};

/**
 * Display the main layout for the grids section
 *
 * @param  {string} licence The current licence
 * @return {ReactNode} The grids layout with left column, desktop sub menu, middle and right columns
 */
const DesktopGridsLayout = ({ licence }: DesktopGridsLayoutProps) => {
  const { location } = useRouter();
  const isGridHistoryRoute = isGridHistory(location.pathname);

  return (
    <GridsLayoutWrapper>
      <DesktopGridsLayoutLeftColumn isGridHistory={isGridHistoryRoute} />
      <GridsDesktopSubMenuContainer />
      <DesktopGridsLayoutMiddleColumn isGridHistory={isGridHistoryRoute} />
      <DesktopGridsLayoutRightColumn isGridHistory={isGridHistoryRoute} licence={licence} />
      <Switch>
        {map(routes, ({ pattern, Tab, exact }, key) => (
          <Route key={key} path={pattern} exact={exact}>
            <Tab />
          </Route>
        ))}
      </Switch>
      <DesktopGridsModalLayout />
    </GridsLayoutWrapper>
  );
};

export default DesktopGridsLayout;
